import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { log } from "./lib/logger/browser-logger";
import "./globals.css";

window.addEventListener("error", (event) => {
  const err = event.error instanceof Error ? event.error : new Error(event.message);
  log.error({ err }, "uncaught error");
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const err = reason instanceof Error ? reason : new Error(String(reason));
  log.error({ err }, "unhandled promise rejection");
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
